const STATUS_WORD_SEPARATOR_PATTERN = /[_-]+/g
const WHITESPACE_PATTERN = /\s+/

// Formats a raw status/type slug (e.g. "pending_approval") as a sentence-case
// label (e.g. "Pending approval") for badge text.
export function formatStatusLabel(value) {
  if (!value) return ''
  const words = String(value).replace(STATUS_WORD_SEPARATOR_PATTERN, ' ').trim().split(WHITESPACE_PATTERN)
  return words
    .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ')
}
